<template>
  <sistema>
    <div>
      <crud-contrato-transportador
        :isSearch="false"
        :isNew="isNew"
        :idContratoTransportador="idContratoTransportador"
      />
    </div>
  </sistema>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import CrudContratoTransportador from "../../components/orcamento/CrudContratoTransportador.vue";

@Options({
  props: {
    isNew: Boolean,
    idContratoTransportador: Number
  },
  components: {
    CrudContratoTransportador
  }
})
export default class ContratoTransportador extends Vue {
  isNew?: boolean;
  idContratoTransportador?: number;
}
</script>

<style scoped lang="scss"></style>
